import { reviewLine } from './reviewIdentity';

/**
 * "Reviewed by Ann Lee on 10/7/2026" under a reviewed item (D6). Renders
 * nothing for an item with no review, such as one reviewed before D6.
 */
export default function ReviewStamp({ review, verb = 'Reviewed' }) {
    const line = reviewLine(review, verb);
    return line ? <div className="review-stamp">{line}</div> : null;
}
